module.exports = __webpack_public_path__ + "static/img/list-item-2.2a5f274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-2.png
// module id = qnmh
// module chunks = 1